import { DashboardT } from 'business/definitions';
import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';

export const GET_DASHBOARD_FILTERS_CACHE_KEY = 'getDashboardFilters';

const useGetDashboardFilters = (
    dashboard: DashboardT | undefined,
    publicToken?: string | null,
) => {
    const dashboardKey = dashboard?.key;
    const dashboardSlug = dashboard?.slug;
    const baseEndpoint = `explore/dashboard/${dashboardSlug}/filters`;
    const endpoint = publicToken
        ? `${baseEndpoint}?public_token=${publicToken}`
        : baseEndpoint;
    return useQuery({
        queryKey: [GET_DASHBOARD_FILTERS_CACHE_KEY, dashboardKey],

        queryFn: async () => {
            const response = await RQAPICallWithData<DashboardFilterT[]>({
                endpoint,
                method: 'GET',
            });
            return response.content.data;
        },

        enabled: !!dashboardKey && !!dashboardSlug,
    });
};

export default useGetDashboardFilters;
